import type { FunctionComponent } from 'react';

import { getDateDeltaString } from '@trello/dates/i18n';
import { forNamespace } from '@trello/legacy-i18n';

import type { RelativeDateEntity } from './types';

const format = forNamespace('notificationsGrouped');

interface RelativeDateProps extends Pick<RelativeDateEntity, 'date'> {
  now?: Date;
  notificationType?: string;
}

// TODO: Date refreshing ?

const getCurrentDateString = (
  dateString: string,
  now: Date,
  notificationType?: string,
) => {
  const date = new Date(dateString);
  const period = getDateDeltaString(date, now);
  // we want to use strings that start with a lower case for check item due soon
  // notifications since the check item name and list will precede the relative
  // date
  const useLowerCase = notificationType === 'checkItemDueSoon';
  const relativeDateKey = useLowerCase
    ? date > now
      ? 'notification_is_due_lower_case'
      : 'notification_was_due_lower_case'
    : date > now
      ? 'notification_is_due'
      : 'notification_was_due';

  return <span>{format(relativeDateKey, { period })}</span>;
};

export const RelativeDate: FunctionComponent<RelativeDateProps> = ({
  date,
  // eslint-disable-next-line @eslint-react/no-unstable-default-props -- FIXME
  now = new Date(),
  notificationType,
}) => {
  const currentDateString = getCurrentDateString(date, now, notificationType);

  return <span>{currentDateString}</span>;
};
